import { getView } from '@/lib/utils';

export default {
  path: '/system-error',
  name: 'systemError',
  component: getView('pages/PageSystemError'),
};
